import React from 'react';
import { Bonuses } from './components/Bonuses';
import { Differentiators } from './components/Differentiators';
import { Faq } from './components/Faq';
import { FinalClose } from './components/FinalClose';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { LookInside } from './components/LookInside';
import { MetaPixel, PIXEL_ID } from './components/MetaPixel';
import { Pricing } from './components/Offers';
import { ProblemSolution } from './components/ProblemSolution';
import { ProductShowcase } from './components/ProductShowcase';
import { PurchasePopup } from './components/PurchasePopup';
import { Testimonials } from './components/Testimonials';
import { Volumes } from './components/Volumes';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-slate-50 text-brand-deep selection:bg-accent-light selection:text-brand-deep" data-id="element-0" data-mp="28ufpyg1ohml6">
      <MetaPixel data-id="element-1" data-mp="23u9v6r043jyv" />
      <main data-id="element-2" data-mp="23utb6267bya9">
        <Hero data-id="element-3" data-mp="23t8heerpojdg" />
        <ProblemSolution data-id="element-4" data-mp="23ti67z10skhk" />
        <ProductShowcase data-id="element-5" data-mp="3ikhaeg9qb525" />
        <Volumes data-id="element-6" data-mp="3ij63w8owfj7c" />
        <LookInside data-id="element-7" data-mp="3ijpc2xoqyt86" />
        <Bonuses data-id="element-8" data-mp="3ii4qvyobommz" />
        <Pricing id="offer" titleId="offer-title" data-id="element-9" data-mp="3mlax56bfqdtg" />
        <Differentiators data-id="element-10" data-mp="3mjzpgvevclx2" />
        <Testimonials data-id="element-11" data-mp="3mj6jhwnqi0fz" />
        <Faq data-id="element-12" data-mp="3rbra6pbcfxfa" />
        <FinalClose data-id="element-13" data-mp="3rbzq6q2rjiup" />
      </main>
      <Footer data-id="element-14" data-mp="3rd1a7k1rbfok" />
      <PurchasePopup data-id="element-15" data-mp="3reltuemj9e7n" />
      <noscript data-id="element-16" data-mp="5or2zhbcs60">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-17" data-mp="67yvnd9206b" />
      </noscript>
    </div>;
}